"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./EventCard.scss");
var _generateLinks = require("../../utils/generateLinks");
var _removeSpaces = require("../../utils/removeSpaces");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const EventCard = _ref => {
  let {
    content = {}
  } = _ref;
  const {
    date,
    year,
    industry,
    industryLabel,
    name,
    location,
    description,
    image,
    link = {},
    Link
  } = content;
  const {
    mouse
  } = (0, _useMouse.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mep-event-card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mep-event-card__date-section"
  }, date && /*#__PURE__*/_react.default.createElement("p", {
    className: "mep-event-card__date"
  }, date), year && /*#__PURE__*/_react.default.createElement("p", {
    className: "mep-event-card__year"
  }, year)), image && /*#__PURE__*/_react.default.createElement("img", {
    className: "mep-event-card__image",
    src: (0, _removeSpaces.removeSpaces)(image.url || image.src),
    alt: image.altText || image.alt ? image.altText || image.alt : ""
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "mep-event-card__details"
  }, industry && /*#__PURE__*/_react.default.createElement("p", {
    className: "mep-event-card__industry"
  }, /*#__PURE__*/_react.default.createElement("span", null, industryLabel || "Industry", ":"), " ", industry), name && /*#__PURE__*/_react.default.createElement("p", {
    className: "mep-event-card__name"
  }, name), description && /*#__PURE__*/_react.default.createElement("p", {
    className: "mep-event-card__description"
  }, description), location && /*#__PURE__*/_react.default.createElement("p", {
    className: "mep-event-card__location"
  }, location)), /*#__PURE__*/_react.default.createElement(_generateLinks.IconLink, {
    url: link.url || "",
    Link: Link
  }, /*#__PURE__*/_react.default.createElement("span", {
    tabIndex: mouse ? "" : "0",
    className: mouse ? "" : "mep-event-card__focus"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "16px",
    type: "open-caret-right-dark-16px"
  }))));
};
var _default = EventCard;
exports.default = _default;